/*
 * Copyright (C) 2020 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { Injectable } from '@angular/core';
import { ResourceSubheaderUpdateRequest } from '../../models';
import { ObservableResult } from '../../store';
import { SubheaderDataService } from './subheader-data.service';

@Injectable()
export class MockSubheaderDataService implements SubheaderDataService {
  updatePlaylistSubheader(playlistUid: string, subheader: ResourceSubheaderUpdateRequest): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }
  updateCardSubheader(cardUid: string, subheader: ResourceSubheaderUpdateRequest): ObservableResult<void> {
    return ObservableResult.ofSuccess();
  }
}
